import * as tslib_1 from "tslib";
import { jsonArrayMember, jsonMember, jsonObject } from "typedjson";
import { DxPageHeaderItemOptions } from "./dx-page-header-item-options";
/**
 * Класс опций группы элементов шапки страницы.
 * @publicApi
 */
let DxPageHeaderGroupOptions = class DxPageHeaderGroupOptions {
    /**
     * Класс опций группы элементов шапки страницы.
     * @publicApi
     */
    constructor() {
        /**
         * Порядок следования гуппы элементов в шапке.
         * @name _ord
         * @type {number}
         * @defaultValue - 0
         */
        this._ord = 0;
        /**
         * Массив элементов шапки, принадлежахих данной группе.
         * @name _items
         * @type {DxPageHeaderItemOptions[]}
         * @defaultValue - пустой массив.
         */
        this._items = [];
    }
    /**
     * Возвращает порядок следования гуппы элементов в шапке.
     * @return {number} - порядок следования гуппы элементов в шапке.
     * @public
     */
    get ord() {
        return this._ord;
    }
    /**
     * Устанавливает порядок следования гуппы элементов в шапке.
     * @param {number} value - порядок следования гуппы элементов в шапке.
     * @public
     */
    set ord(value) {
        this._ord = value;
    }
    /**
     * Возвращает массив элементов шапки, принадлежахих данной группе.
     * @return {DxPageHeaderItemOptions[]} - массив элементов в шапки, принадлежахих данной группе.
     * @public
     */
    get items() {
        return this._items;
    }
    /**
     * Устанавливает массив элементов шапки, принадлежахих данной группе.
     * @param {DxPageHeaderItemOptions[]} value - массив элементов в шапки, принадлежахих данной группе.
     * @public
     */
    set items(value) {
        this._items = value;
    }
};
tslib_1.__decorate([
    jsonMember({ name: "ord", constructor: Number, emitDefaultValue: true, isRequired: false }),
    tslib_1.__metadata("design:type", Number)
], DxPageHeaderGroupOptions.prototype, "_ord", void 0);
tslib_1.__decorate([
    jsonArrayMember(DxPageHeaderItemOptions, { name: 'items', isRequired: false, emitDefaultValue: false }),
    tslib_1.__metadata("design:type", Array)
], DxPageHeaderGroupOptions.prototype, "_items", void 0);
DxPageHeaderGroupOptions = tslib_1.__decorate([
    jsonObject
], DxPageHeaderGroupOptions);
export { DxPageHeaderGroupOptions };
